import { useSelector } from "react-redux";
import { AppState } from "../store/configureStore";
import { getDestinationTimeZone } from "../helpers/dateHelper";

/** Explicit entity destination takes priority; dispatcher-wide views use the company destination. */
export function useDestinationTimeZone(destinationId?: string | null, dockId?: string | null) {
    return useSelector((state: AppState) => {
        const id = destinationId || (dockId ? state.docks.data.get(dockId)?.destinationId : undefined);
        const zone = id ? state.destinationZones.data.get(id) :
            state.destinationZones.companyZones?.get(state.user.companyId ?? "");
        return getDestinationTimeZone(zone);
    });
}
